import React, { memo, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Img from "react-image";
import { Link } from "react-router-dom";
import { getRecentlyViewedProducts } from "../../../redux/actions/common.action";
// import { AnalyticService } from "../../../services";
import useSwiperScript from "@/hooks/useSwiperScript";
import { useIsRTL, useRouteSlug } from "@/hooks";
import { selectCdnImageSettings } from "../../../util/selectors";
import { isServer } from "@/util";
import "./style.scss";

const params = {
  slidesPerView: 6,
  rebuildOnUpdate: true,
  freeMode: true,
  spaceBetween: 10,
  cssMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  breakpoints: {
    1024: {
      slidesPerView: 9,
      spaceBetween: 8
    },
    800: {
      slidesPerView: 5
    },
    600: {
      slidesPerView: 4.5
    },
    475: {
      slidesPerView: 3.5
    }
  }
};

const RecentlyViewedProducts = () => {
  const [recentlyViewed, setRecentlyViewed] = useState([]);
  const { t } = useTranslation("productDetails");

  const isArabic = useIsRTL();
  const configCdnImagesSettings = useSelector(selectCdnImageSettings);
  const routeSlug = useRouteSlug();
  const swiperRef = useRef(null);
  const loadedScriptStatus = useSwiperScript();

  const isSwiperExist = Boolean(!isServer && window.Swiper);
  const isScriptLoaded = Boolean(loadedScriptStatus || isSwiperExist);

  useEffect(() => {
    const recentlyViewed = getRecentlyViewedProducts();
    setRecentlyViewed(recentlyViewed);
  }, []);

  useEffect(() => {
    if (swiperRef.current && recentlyViewed.length > 0 && isScriptLoaded) {
      new window.Swiper(swiperRef.current, params);
    }
  }, [recentlyViewed, swiperRef, loadedScriptStatus]);

  // const moveToProductDetail = item => {
  //     AnalyticService.product.trackMoveToProductDetail({
  //       item,
  //       authReducer,
  //       commonSettings
  //     });
  // };

  return (
    <>
      {Boolean(recentlyViewed?.length) && isScriptLoaded && (
        <div className="recentlyViewed">
          <h2 className="section_heading">{t("RecentlyViewed")}</h2>
          <div className="recently_viewed_slider_wrap">
            <div
              className="swiper"
              ref={swiperRef}
              dir={isArabic ? "rtl" : "ltr"}
            >
              <div className="swiper-wrapper">
                {recentlyViewed.map((item, index) => (
                  <div className="swiper-slide" key={index}>
                    <div
                      className="img_grid_wrapper"
                      // onClick={e => moveToProductDetail(item)}
                    >
                      <Link to={`/${routeSlug}/${item.url}`}>
                        <Img
                          decode={false}
                          src={`${configCdnImagesSettings?.main}${item.captionImageURL}`}
                          style={{ width: "100% " }}
                        />
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default memo(RecentlyViewedProducts);
